<template>
    <div>
        <b-dropdown
            name="bulkActions"
            variant="outline-secondary"
            class="btn-block"
            :disabled="selectedRows === 0"
        >
            <template v-slot:button-content>
                <font-awesome-icon icon="tasks" />
                {{ bulkOptionsText }}
            </template>

            <span class="ml-4">Total selected: {{ selectedRows }}</span>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item
                @click="print(FETCH_LABELS)"
                name="printAwbBulkButton"
            >
                {{
                $t('history.buttons.PrintAWB')
                }}
            </b-dropdown-item>
            <b-dropdown-item
                @click="print(FETCH_MANIFEST)"
                name="printManifestBulkButton"
            >
                {{
                $t('history.buttons.PrintManifest')
                }}
            </b-dropdown-item>
            <b-dropdown-item
                @click="print(FETCH_CSV)"
                name="exportToExcelBulkButton"
            >
                {{
                    $t('history.buttons.ExportToExcel')
                }}
            </b-dropdown-item>
            <b-dropdown-item
                @click="print(FETCH_LABEL_AND_DOCUMENTS)"
                name="printAwbAndDocumentsBulkButton"
            >{{ $t('history.buttons.PrintAWBDocuments') }}</b-dropdown-item>
            <b-dropdown-item
                name="printAwbAndDocumentsWithoutConnoteBulkButton"
                @click="print(FETCH_LABEL_AND_DOCUMENTS_WITHOUT_CONNOTE)"
            >{{ $t('history.buttons.PrintAWBDocumentsWithoutConnote') }}</b-dropdown-item>
            <b-dropdown-item
                v-if="isAdminOrSuperUser"
                @click="openMarkAsDelivered"
                name="changeTransitStatusBulkButton"
            >{{ $t('history.buttons.ChangeTransitStatus') }}</b-dropdown-item>
            <b-dropdown-item
                v-if="isFinanceUser"
                @click="openTransferToCargoWise"
                name="transferToCargowiseBulkButton"
            >{{ $t('history.buttons.TransferToCargoWise') }}</b-dropdown-item>
          <b-dropdown-item
              v-if="isFinanceUser"
              @click="openTransferToInvoice"
              name="transferToInvoiceBulkButton"
          >{{ $t('history.buttons.TransferToInvoice') }}</b-dropdown-item>
            <b-dropdown-item
                v-if="isAdminOrSuperUser"
                @click="changeAccount"
                name="changeAccount"
            >{{$t('history.buttons.ChangeAccount')}}</b-dropdown-item>
            <b-dropdown-item
                v-if="isAdminOrSuperUser"
                @click="displayConfirmModel"
                name="deleteShipments"
            >{{$t('history.buttons.DeleteShipments')}}</b-dropdown-item>
        </b-dropdown>

        <changeTransitStatus
            ref="transit-status-modal"
            @updateTransitStatus="updateTransitStatus"
        ></changeTransitStatus>

        <transferShipmentsToCargoWise
            ref="cargowise-transfer-modal"
            @transferShipmentsToCW1="transferShipmentsToCW1"
        ></transferShipmentsToCargoWise>
        <TransferShipmentsToInvoicingAction ref="invoicing-transfer-modal" @transferShipmentToInvoicing="transferShipmentToInvoicing" />

        <ChangeShipmentAccountModule ref="change-shipment-account-modal" />

        <confirmModal
            ref="deleteConfirmModal"
            @confirmAction="deleteShipments"
        />
    </div>
</template>
<script>
  import store from '../../store';
  import { CORE_PREFIX, ACTIONS, MUTATIONS, HISTORY_PREFIX } from '../../store/constants';
  import { mapGetters } from 'vuex';
  import changeTransitStatus from './Actions/changeTransitStatusAction';
  import transferShipmentsToCargoWise from './Actions/transferShipmentsToCargoWiseAction';
  import transferShipmentsToInvoicing from './Actions/transferShipmentsToInvoicingAction.vue';
  import viewOptions from '../../mixins/viewOptionsMixin';
  import ChangeShipmentAccountModule from '@/components/History/Actions/ChangeShipmentAccountModule';
  import confirmModal from '../confirmModal';
  import TransferShipmentsToInvoicingAction from "@/components/History/Actions/transferShipmentsToInvoicingAction.vue";

  export default {
      components: {
        TransferShipmentsToInvoicingAction,
          changeTransitStatus,
          transferShipmentsToCargoWise,
          ChangeShipmentAccountModule,
          confirmModal,
      },
      props: {
          selectedRows: { required: true },
      },

      mixins: [viewOptions],
      data() {
          return {
              FETCH_LABELS: ACTIONS.HISTORY.FETCH_LABELS,
              FETCH_MANIFEST: ACTIONS.HISTORY.FETCH_MANIFEST,
              FETCH_CSV: ACTIONS.HISTORY.FETCH_CSV,
              FETCH_LABEL_AND_DOCUMENTS_WITHOUT_CONNOTE:
                  ACTIONS.HISTORY.FETCH_LABEL_AND_DOCUMENTS_WITHOUT_CONNOTE,
              FETCH_LABEL_AND_DOCUMENTS: ACTIONS.HISTORY.FETCH_LABEL_AND_DOCUMENTS,
          };
      },
      computed: {
          ...mapGetters('core', ['isCustomer', 'isAdminOrSuperUser', 'isFinanceUser']),
          ...mapGetters('history', ['getSelectedRows']),

          bulkOptionsText() {
              if (this.selectedRows > 0) {
                  return 'Bulk Actions (' + this.selectedRows + ')';
              } else {
                  return 'Bulk Actions';
              }
          },
      },
      methods: {
          changeAccount() {
              const shipmentIds = this.getSelectedRows.map((x) => x.id);
              this.$refs['change-shipment-account-modal'].show(shipmentIds);
          },
          updateTransitStatus(value) {
              var request = {
                  shipmentIds: this.getSelectedRows.map((x) => x.id),
                  deliveryStatus: value,
              };

              this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.UPDATE_TRANSIT_STATUS, request);
          },

          transferShipmentsToCW1() {
              const shipmentIds = this.getSelectedRows.map((x) => x.id);
              this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.TRANSFER_SHIPMENTS, shipmentIds);
          },
          transferShipmentToInvoicing() {
            const shipmentIds = this.getSelectedRows.map((x) => x.id);
            this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.TRANSFER_SHIPMENT_INVOICING, shipmentIds);
          },

          displayConfirmModel() {
              this.$refs['deleteConfirmModal'].show();
          },

          deleteShipments() {
              const shipmentIds = this.getSelectedRows.map((x) => x.id);
              this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.DELETE_SHIPMENTS, shipmentIds);
          },

          async print(key) {
              const link = await this.$store.dispatch(HISTORY_PREFIX + key);
              if (link) {
                  window.open(link, '_blank');
              }
          },
          openMarkAsDelivered() {
              this.$refs['transit-status-modal'].showTransitStatusModal();
          },
          openTransferToCargoWise() {
              this.$refs['cargowise-transfer-modal'].showCargoWiseTransferModal();
          },
          openTransferToInvoice() {
          this.$refs['invoicing-transfer-modal'].showCargoWiseTransferModal();
        },
      },
  };
</script>

<style></style>
